import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'CANDIDATE_ONEWAYINTERVIEW_INVITATION_SHOW_ERROR':
      return action.error;

    case 'CANDIDATE_ONEWAYINTERVIEW_INVITATION_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'CANDIDATE_ONEWAYINTERVIEW_INVITATION_SHOW_LOADING':
      return action.loading;

    case 'CANDIDATE_ONEWAYINTERVIEW_INVITATION_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'CANDIDATE_ONEWAYINTERVIEW_INVITATION_SHOW_SUCCESS':
      return action.retrieved;

    case 'CANDIDATE_ONEWAYINTERVIEW_INVITATION_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved });
